import { ForwardedRef } from "react";
import FontBody2 from "../../../fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../fonts/font-props";
import IconCalendar from "../../../icons/icon-calendar/icon-calendar";
import IconDropDownArrow from "../../../icons/icon-drop-down-arrow/icon-drop-down-arrow";
import Icon from "../../../icons/icon/icon";
import {IDateRange} from "../../date-range-picker-v2";

interface ISelectedValueProps {
    disabled?: boolean,
    reference: ForwardedRef<HTMLDivElement>,
    datePreview: React.ReactNode,
    value?: IDateRange,
    onClick: () => void,
}

const SelectedValue: React.FC<ISelectedValueProps> = ({ disabled, reference, datePreview, value, onClick }) => {
    const getTextColor = () => {
        if (disabled) {
            return FONT_COLOR.PRIMARY3_50;
        }

        if (!value || (!value.from && !value.to)) {
            return FONT_COLOR.PRIMARY3;
        }
        
        return FONT_COLOR.ACCENT1;
    }

    return (
        <div className="date-range-filter-container" ref={reference} onClick={onClick}>
            <span className="title">
                <Icon Component={IconCalendar} />
                <FontBody2 color={getTextColor()}>{datePreview}</FontBody2>
            </span>
            <Icon Component={IconDropDownArrow} />
        </div>
    );
};

export default SelectedValue;